import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostBinding,
    Input,
    OnDestroy,
    Output,
    ViewChild,
} from '@angular/core';
import { ResizeSensor } from 'css-element-queries';

import { ElasticTabConfig } from './models/oa.model';
import { TeamOAService } from './services/team-oa.service';

// maintain a list of Team Member Metrics
@Component({
    selector: 'elastic-tabs',
    templateUrl: './elastic-tabs.component.html',
    host: {
        class: ' elastic-tabs ',
    },
})
export class ElasticTabsComponent implements AfterViewInit, OnDestroy {
    @Input() tabsconfig: ElasticTabConfig[];
    @Input() inputclass: string;
    @Input() input: any;

    @Output() resized: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('tabsList', { static: true }) tabList;
    @ViewChild('showMoreBtn', { static: true }) showMoreBtn;

    @HostBinding('style.height') elementHeight: string = '';
    @HostBinding('class.displayed') displayMore: boolean = false;
    @HostBinding('class.wrapped-tabs') public wrapped: boolean = false;

    public listWidth: number = null;
    public listHeight: number = null;

    public btnWidth: number = null;
    public btnHeight: number = null;

    public minBtnWidth: any = null;

    public childrenCount: number = null;

    public listPadding: number = null;

    public showMore: boolean = false;

    public listener;

    constructor(
        protected _teamOAService: TeamOAService,
        public _el: ElementRef,
    ) {}

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngAfterViewInit() {
        // setTimeout(() => {

        this.listener = new ResizeSensor(
            this.tabList.nativeElement,
            (dimensions) => {
                this.update(dimensions);
            },
        );

        const o = this.tabList.nativeElement.getBoundingClientRect();

        this.childrenCount = this.tabList.nativeElement.children.length;
        const firstchild = this.childrenCount
            ? this.tabList.nativeElement.children[0]
            : null;
        const childdim = firstchild ? firstchild.getBoundingClientRect() : null;

        const sbbStyle = document.defaultView.getComputedStyle(firstchild, '');
        if (sbbStyle) {
            this.minBtnWidth = sbbStyle.minWidth;
        }

        if (childdim) {
            this.btnWidth = childdim.width;
            this.btnHeight = childdim.height;

            this.listWidth = this.childrenCount * this.btnWidth;
            this.listHeight = this.btnHeight;
        }

        this.elementHeight = `${this.listHeight}px`;

        // initial render
        this.update({
            height: o.height,
            width: o.width,
        });

        // });
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    ngOnDestroy() {
        if (this.listener) {
            this.listener.reset();
            this.listener.detach();
        }
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    toggleTabs(force?: boolean) {
        this.displayMore = force != null ? force : !this.displayMore;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    update(dims: any = null) {
        const currentheight = dims ? dims.height : this.listHeight;
        const currentwidth = dims ? dims.width : this.listWidth;

        if (currentheight > this.listHeight + 10) {
            this.wrapped = this.showMore = true;

            setTimeout(() => {
                if (this.showMoreBtn) {
                    const width =
                        this.showMoreBtn.nativeElement.getBoundingClientRect()
                            .width;
                    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                    this.listPadding = width + 15;
                    this.resized.emit(true);
                }

                if (this.checkIfTabsFitHorizontally(currentwidth)) {
                    this.wrapped = this.showMore = false;
                    this.resized.emit(false);
                }
            }, 1);
        } else {
            this.wrapped = this.showMore = false;
            this.listPadding = 0;
            this.resized.emit(false);
        }

        this.displayMore = false;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    checkIfTabsFitHorizontally(currentWidth) {
        let btnwidth = this.minBtnWidth.replace('px', '');
        btnwidth = Number(btnwidth);

        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return this.childrenCount * btnwidth + 15 <= currentWidth + 50;
    }
}
